<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="550px"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("import") }}</span>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs6>
                                <v-select
                                    v-model="species"
                                    :items="speciesList"
                                    item-text="species"
                                    :label="`${$t('speciesAlt')} *`"
                                    return-object
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <v-select
                                    v-model="boardType"
                                    :items="boardTypesList"
                                    item-text="title"
                                    item-value="id"
                                    :label="`${$t('boardType')} *`"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <upload-btn
                                    flat
                                    flex
                                    noTitleUpdate
                                    title=""
                                    @file-update="onFileUpdate"
                                    ref="uploadButton"
                                    color="primary"
                                    class="w-100 pl-0"
                                >
                                    <template slot="icon">
                                        {{ $t("selectFile") }}
                                    </template>
                                </upload-btn>
                            </v-flex>
                            <!--
                            <v-flex xs8>
                                <div class="file">
                                    {{fileName}}
                                </div>
                            </v-flex>
                            -->

                            <v-card-text
                                class="dense v-scrollable mt-4"
                                v-if="boardType == 0 || boardType == 2"
                                style="overflow-x: auto; max-height: 250px;"
                            >
                                <template>
                                    <v-data-table
                                        v-model="boardsSelected"
                                        item-key="uid"
                                        :headers="boardsHeader"
                                        :items="boardsCentral"
                                        :rows-per-page-items="[100]"
                                        select-all
                                        hide-actions
                                        class="dense-table"
                                    >
                                        <template v-slot:items="props">
                                            <td>
                                                <v-checkbox
                                                    v-model="props.selected"
                                                    primary
                                                    hide-details
                                                ></v-checkbox>
                                            </td>
                                            <td>{{ props.item.size }}</td>
                                            <td>{{ props.item.sawSize }}</td>
                                            <td>{{ props.item.price }}</td>
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-card-text>

                            <v-card-text
                                class="dense v-scrollable mt-4"
                                v-if="boardType == 1"
                                style="overflow-x: auto; max-height: 250px;"
                            >
                                <template>
                                    <v-data-table
                                        v-model="boardsSelected"
                                        item-key="uid"
                                        :headers="boardsHeader"
                                        :items="boardsSide"
                                        :rows-per-page-items="[100]"
                                        select-all
                                        hide-actions
                                        class="dense-table"
                                    >
                                        <template v-slot:items="props">
                                            <td>
                                                <v-checkbox
                                                    v-model="props.selected"
                                                    primary
                                                    hide-details
                                                ></v-checkbox>
                                            </td>
                                            <td>{{ props.item.size }}</td>
                                            <td>{{ props.item.sawSize }}</td>
                                            <td>{{ props.item.price }}</td>
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-card-text>

                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        @click="saveDataClick"
                        :disabled="!species.id || !boardsSelected[0] || boardType == 2"
                    >
                        {{ $t("load") }}
                    </v-btn>
                    <v-btn color="error" @click="closeDialogClick">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import MessageBox   from "./MessageBox";
    import UploadButton from "vuetify-upload-button";

    export default {
        name: "LumberImportDialog",

        components: {
            MessageBox,
            "upload-btn": UploadButton
        },

        data () {
            return {
                dialog: false,
                company: {
                    id: 0,
                    name: ""
                },
                boardType: 2,
                boardTypesList: [
                    { id: 0, title: this.$t("centralBoard") },
                    { id: 1, title: this.$t("sideBoard") }
                ],
                species: {},
                speciesList: [],
                centralParsedBoards: [],
                sideParsedBoards: [],
                boardsSelected: [],
                boardsHeader: [
                    { text: "Сечение",        value: "size",    align: "left", sortable: true },
                    { text: "Пильный размер", value: "sawSize", align: "left", sortable: true },
                    //{ text: "Длина, м",       value: "length",  align: "left" },
                    { text: "Цена за м3",     value: "price",   align: "left", sortable: true },
                ],
                boardsCentral: [],
                boardsSide: [],
                fileName: "Файл не выбран",
                alert:     "",
                alertType: "success",
            }
        },

        mounted () {
            this.loadSpecies();
        },

        watch: {
            boardType: function() {
                this.fileName = this.$t("fileNotSelected");
            },

            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            }
        },

        methods: {
            /**
             * Загрузка списка пород
             */
            loadSpecies () {
                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.speciesList = [];

                            speciesInfo.forEach((item) => {
                                if (item.Visible) {
                                    this.speciesList.push({
                                        id:      item.id,
                                        species: this.$t(item.Name)
                                    });
                                }
                            });
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " +this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Обработчик события изменения файла
             *
             * @param {object} file Описание файла
             */
            onFileUpdate (file) {
                if (file !== undefined) {
                    let reader = new FileReader();
                    let rawData;

                    let parentElm = this;

                    reader.onload = function() {
                        rawData = reader.result;

                        let lines   = rawData.split("\n");
                        let outData = [];

                        parentElm.boardsCentral = [];
                        parentElm.boardsSide    = [];

                        lines.forEach((line) => {
                            let lineData = line.split(";");

                            if (lineData.length > 1) {
                                outData.push({
                                    id:    parseInt(lineData[0]),
                                    tn:    lineData.length > 1 ? parseInt(lineData[1])/10 : 0,
                                    wn:    lineData.length > 2 ? parseInt(lineData[2])/10 : 0,
                                    ts:    lineData.length > 3 ? parseFloat(lineData[3].replaceAll(",", ".")) : 0,
                                    ws:    lineData.length > 4 ? parseFloat(lineData[4].replaceAll(",", ".")) : 0,
                                    price: lineData.length > 5 ? parseFloat(lineData[5].replaceAll(",", ".")) : 0,
                                    l1:    lineData.length > 6 ? parseInt(lineData[6]) : 0,
                                    l2:    lineData.length > 7 ? parseInt(lineData[7]) : 0
                                });

                                if (parentElm.boardType == 0) {
                                    parentElm.boardsCentral.push({
                                        id:      parseInt(lineData[0]),
                                        uid:     (parentElm.boardType ? "s" : "c") + parseInt(lineData[0]),
                                        size:    `${ parseInt(lineData[1])/10 } x ${ parseInt(lineData[2])/10 }`,
                                        sawSize: `${ parseFloat(lineData[3].replaceAll(",", ".")) } x ${ parseFloat(lineData[4].replaceAll(",", ".")) }`,
                                        length:  [],
                                        price:   parseFloat(lineData[5].replaceAll(",", ".")),
                                        tn:      parseInt(lineData[1])/10,
                                        wn:      parseInt(lineData[2])/10,
                                        ts:      parseFloat(lineData[3].replaceAll(",", ".")),
                                        ws:      parseFloat(lineData[4].replaceAll(",", "."))
                                    });
                                } else {
                                    parentElm.boardsSide.push({
                                        id:      parseInt(lineData[0]),
                                        uid:     (parentElm.boardType ? "s" : "c") + parseInt(lineData[0]),
                                        size:    `${ parseInt(lineData[1])/10 } x ${ parseInt(lineData[2])/10 }`,
                                        sawSize: `${ parseFloat(lineData[3].replaceAll(",", ".")) } x ${ parseFloat(lineData[4].replaceAll(",", ".")) }`,
                                        length:  [],
                                        price:   parseFloat(lineData[5].replaceAll(",", ".")),
                                        tn:      parseInt(lineData[1])/10,
                                        wn:      parseInt(lineData[2])/10,
                                        ts:      parseFloat(lineData[3].replaceAll(",", ".")),
                                        ws:      parseFloat(lineData[4].replaceAll(",", "."))
                                    });
                                }
                            }
                        });
                    }

                    reader.readAsText(file);
                }
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                this.boardsSelected.forEach((item) => {
                    item.CompanyId = this.company.id;
                    item.price     = parseInt(item.price);
                    item.length    = "[]";
                    this.createBoard(item);
                });
            },

            /**
             * Создание доски
             *
             * @param {object} board Информация о доске
             */
            createBoard (board) {
                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}lumber/`,
                    data: {
                        CompanyId:   board.CompanyId,
                        speciesId:   this.species.id,
                        Tn:          board.tn,
                        Wn:          board.wn,
                        Ts:          board.ts,
                        Ws:          board.ws,
                        BoardType:   this.boardType,
                        LengthsJSON: board.length,
                        Price:       board.price
                    },
                    withCredentials: true
                }).then(() => {
                    //this.$debug.log(response);

                    this.alert = this.$t("dataSaved");
                }).catch(error => {
                    if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveData") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantSaveData"));
                    }
                });

            },

            /**
             * Отслеживание нажатия кнопки закрытия диалога
             */
            closeDialogClick () {
                this.dialog        = false;
                this.boardsCentral = [];
                this.boardsSide    = [];
                this.fileName      = this.$t("fileNotSelected");
                this.species       = {};
                this.boardType     = 2;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },
        }
    }

</script>

<style lang="sass" scoped>
    .file
        padding-top: 4%
        padding-left: 12px

</style>

<style lang="sass">
    .upload-btn.w-100
        .v-btn
            width: 100% !important
            .v-btn__content
                width: 100%
</style>